import StockMatchSummary from "./stock-match-chart";
import NoMatchSection from "./no-match-section";
import { useNavigate, useLocation } from "react-router-dom";
import Dropdown from "../../Components/CustomDropdown/customdropdown";
import React, { useState, useEffect, useRef, useCallback } from "react";

const SuggestedStrategies = () => {
  const [isMatchFound, setIsMatchFound] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, settotalCount] = useState(0);
  const [totalPages, settotalPages] = useState(0);
  const [showRecords, setShowRecords] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoadingPortfolio, setIsLoadingPortfolio] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [filterText, setFilterText] = useState("created_at");

  const [portfolioAccounttableData, setPortfolioAccounttableData] = useState([
    {
      portfolio_id: 109,
      portfolio_name: "Caprock100/0 rebalancing",
      portfolio_reference_code: "INV2FEB409C60",
      total_balance: 6952.965500000006,
    },
    {
      portfolio_id: 92,
      portfolio_name:
        "Caprock Funds Management Pty Ltd Multi-Asset SMA Aggressive (100/0)",
      portfolio_reference_code: "INVC350293608",
      total_balance: 18000,
    },
  ]);
  const portfolioAccountheaders = [
    { label: "Investment ID", key: "investment ID" },
    { label: "Investment Product Name", key: "productName" },
    { label: "Matched %", key: "Matched" },
  ];
  const handleshowRecord = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setShowRecords(parseInt(selectedOption.value));
    setCurrentPage(1);
  };
  const handleSort = (key) => {
    setFilterText(key);
  };
  const [preSelectedFilter, setpreSelectedFilter] = useState({
    value: 10,
    label: "10",
  });
  const filterOptions = [
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 30, label: "30" },
    { value: 50, label: "50" },
  ];
  return (
    <div className="lg:min-w-[78vw] lg:max-w-[80vw] pt-0">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      {isMatchFound && (
        <div className="font-medium bg-white mt-6 p-4 rounded-xl shadow-sm border border-gray-200 text-sm text-gray-900">
          {/* Header Section */}
          <div className="flex flex-col md:flex-row md:items-center justify-between mb-4 gap-4">
            <h3 className="text-base font-semibold text-black flex items-center gap-2">
              {/* Replace with any SVG above */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6 text-black"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M3 7l9-4 9 4-9 4-9-4zm0 6l9 4 9-4m-9 4v5"
                />
              </svg>
              Recommended Strategies
            </h3>

            <div className="flex flex-col sm:flex-row sm:items-center gap-3">
              {/* Show Records */}
              <div className="flex items-center gap-2">
                <span className="text-gray-600">Show</span>
                <Dropdown
                  label=""
                  options={filterOptions}
                  preselectedValue={preSelectedFilter}
                  onSelect={handleshowRecord}
                />
              </div>

              {/* Search */}
              <div className="relative w-full sm:w-auto">
                <input
                  type="text"
                  className="pl-9 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-indigo-300 focus:outline-none w-full sm:w-60 text-sm"
                  placeholder="Search strategy"
                  value={searchQuery}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setSearchQuery(e.target.value);
                  }}
                />
                <img
                  src="/search-normal.svg"
                  alt="Search"
                  className="absolute left-3 top-2 w-4 h-4 text-gray-400"
                />
              </div>
            </div>
          </div>

          {/* Table */}
          <div className="overflow-x-auto">
            <table className="min-w-full border-separate border-spacing-y-1 text-sm">
              <thead className="bg-gray-100 text-gray-700">
                <tr>
                  {portfolioAccountheaders.map((header) => (
                    <th
                      key={header.label}
                      onClick={() => handleSort(header.key)}
                      className="px-4 py-2 text-left font-medium cursor-pointer whitespace-nowrap"
                    >
                      <div className="flex items-center space-x-1">
                        <span>{header.label}</span>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {isLoadingPortfolio ? (
                  [...Array(5)].map((_, i) => (
                    <tr
                      key={i}
                      className="rounded border border-gray-100 bg-white"
                    >
                      {[...Array(4)].map((_, j) => (
                        <td key={j} className="px-4 py-3">
                          <div className="h-3 bg-gray-200 rounded animate-pulse"></div>
                        </td>
                      ))}
                    </tr>
                  ))
                ) : portfolioAccounttableData.length > 0 ? (
                  portfolioAccounttableData.map((row, index) => (
                    <tr
                      key={index}
                      className={`transition-colors border border-gray-100 ${
                        index % 2 === 0 ? "bg-white" : "bg-gray-50"
                      } hover:bg-indigo-50`}
                    >
                      <td className="px-4 py-3 whitespace-nowrap">
                        {row.portfolio_reference_code}
                      </td>
                      <td
                        onClick={() => {
                          let redirectState = {
                            path: "/in-depth-strategy-details",
                            state: {
                              from: location.pathname,
                              historyStack: [
                                ...(location.state?.historyStack || []),
                                location.pathname,
                              ],
                            },
                          };
                          sessionStorage.setItem(
                            "redirectAfterLogin",
                            JSON.stringify(redirectState)
                          );
                          navigate("/in-depth-strategy-details", {
                            state: {
                              from: location.pathname,
                              historyStack: [
                                ...(location.state?.historyStack || []),
                                location.pathname,
                              ],
                            },
                          });
                        }}
                        className="px-4 py-3 text-[#005A9C] hover:underline cursor-pointer whitespace-normal font-medium"
                      >
                        Caprock Model portfolio - {row.portfolio_name}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap font-semibold text-emerald-600">
                        34%
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={4}
                      className="px-4 py-4 text-center text-gray-500"
                    >
                      No results found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {!isLoading && (
            <div className="flex flex-col sm:flex-row justify-between items-center mt-4 text-gray-700 text-xs gap-3">
              <div>
                Showing {showRecords * (currentPage - 1) + 1} to{" "}
                {currentPage === totalPages || totalPages === 0
                  ? totalCount
                  : Math.min(showRecords * currentPage, totalCount)}{" "}
                of {totalCount} entries
              </div>
              <div className="flex gap-1">
                <button
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((prev) => prev - 1)}
                  className="px-2.5 py-1 rounded bg-gray-100 hover:bg-gray-200 disabled:opacity-50"
                >
                  Prev
                </button>
                {Array.from({ length: Math.min(totalPages, 5) }).map((_, i) => {
                  const startPage = Math.max(
                    1,
                    Math.min(totalPages - 4, currentPage - 2)
                  );
                  const page = startPage + i;
                  return (
                    <button
                      key={page}
                      onClick={() => setCurrentPage(page)}
                      className={`px-2.5 py-1 rounded ${
                        currentPage === page
                          ? "bg-indigo-600 text-white font-semibold"
                          : "bg-white border border-gray-300 hover:bg-gray-100"
                      }`}
                    >
                      {page}
                    </button>
                  );
                })}
                <button
                  disabled={currentPage === totalPages || totalPages === 0}
                  onClick={() => setCurrentPage((prev) => prev + 1)}
                  className="px-2.5 py-1 rounded bg-gray-100 hover:bg-gray-200 disabled:opacity-50"
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </div>
      )}
      {!isMatchFound && <NoMatchSection />}
      <div className="mt-4">
        <StockMatchSummary />
      </div>
    </div>
  );
};

export default SuggestedStrategies;
